import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { EVENT_Z_INDICES } from '../../../constants';
import { OVERLAP_EVENTS_BUTTON_WIDTH } from './utils';

interface Props {
  hiddenEventsCount: number;
  style?: React.CSSProperties;
}

export const OverflowCountButton = ({ hiddenEventsCount, style }: Props) => {
  const { t } = useTranslation('calendar-grid');
  const ariaLabel = t('Show {{eventCount}} more overlapping events', { eventCount: hiddenEventsCount });
  return (
    <motion.button
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0, zIndex: EVENT_Z_INDICES.appointment }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      css={overlappingEventsButtonStyle}
      style={style}
      aria-label={ariaLabel}
    >
      +{hiddenEventsCount}
    </motion.button>
  );
};

const overlappingEventsButtonStyle = css({
  border: 'none',
  cursor: 'pointer',
  fontWeight: theme.font.weight.semibold,
  fontSize: theme.font.size.medium,
  justifySelf: 'stretch',
  alignSelf: 'start',
  width: OVERLAP_EVENTS_BUTTON_WIDTH,
  height: 40,
  borderRadius: theme.borderRadius.full,
  boxShadow: theme.shadows.light,
  background: theme.colors.white,
  color: theme.colors.neutral90,
  zIndex: EVENT_Z_INDICES.appointment,
  transition: 'box-shadow 0.2s ease-in-out, scale 0.2s ease-in-out, outline 0.1s linear',
  ':hover': {
    scale: 1.02,
    boxShadow: theme.shadows.floating,
  },
});
